import React from 'react';

import Footer from '../Footer/Footer';
import Others from '../Others/Others';
import Services from '../Services/Services';
import Banner from './Banner/Banner';




const Home = () => {



    return (
        <div>
            <Banner></Banner>

            <Services></Services>

            <Others></Others>


            <Footer></Footer>
        </div>





    );


};

export default Home;